export const GOOGLE_MAPS_API_KEY = 'AIzaSyCYebkmhEtL8Rb3gk_yN-gKOV0o9pADmag';

export const COLORS = {
  primary: '#E1F0FF',
  secondary: '#EBEDF3',
  success: '#C9F7F5',
  info: '#EEE5FF',
  warning: '#FFF4DE',
  danger: '#FFE2E5',
};
